/**
 * 重要提示：
 * 1、此文件会在外部文件被引用，修改此文件时，请确认是否会影响外部使用
 * 2、此文件变动，应检查一下otp平台是否也需要变动
 */


const isAdvance = config => config && config.type === 'advance';
const isNotAdvance = config => !isAdvance(config);

// 判断是不是服务平台
const isSiteAdvance = config => {
    if (isNotAdvance(config)) return false;
    const values = ['siteName', 'siteNames', 'siteNameList'];
    const urls = ['/user/auth/data/site/query', '/searchPlatform'];
    return values.includes(config.value) && urls.includes(config.advanceUrl);
};

// 是否供应商
const isSupplierAdvance = config => {
    if (isNotAdvance(config)) return false;
    // ... 此处实现相关逻辑
};

/** 根据不同类型，返回相等判断需要匹配的字段列表, 这些字段相等则可判断两条数据是一条
 *  注意：
 *     1、这些字段组合应确定唯一数据行
 *     2、返回的字段列表，应按照确定唯一性权重排序，如id，code排最前面
 * @param {object} config 属性配置对象
 * @returns array
 */
export function getCompareKeys(config) {
    if (isSiteAdvance(config)) { // 服务平台
        return ['escoCompanyNo'];
    }
    if (isSupplierAdvance(config)) { // 供应商
        return ['supplierCode'];
    }
    return [];
}

/** 判断是否可以使用otpAdvanceForSearch组件, 此组件支持多选回显和checkBox */
export function isEnableUseAdvanceDialogV2(config) {
    if (isNotAdvance(config)) return false;
    if (isSiteAdvance(config)) return true;
    // if (isSupplierAdvance(config)) return true;
    return false;
}

/**
 * advance类型的缓存类
 */
export class AdvanceCache {
    constructor() {
        this.cache = {};
    }
    /**
     * 设置缓存对象
     * @param {object} config advance类型配置对象
     * @param {array} list 缓存列表
     * @returns void
     */
    set(config, list) {
        const prop = config.value;
        this.cache[prop] = [].concat(list).filter(Boolean);
    }
    /** 获取缓存对象
     * @param {object} config advance类型配置对象;
     * @returns array
     */
    get(config, searchData) {
        const prop = config.value;
        const virtualCache = this.makeVirtualCache(config, searchData);
        const localCache = this.cache[prop] || [];
        // 优先使用本地缓存
        if (this.isSameCaches(config, localCache, virtualCache)) {
            return localCache;
        }
        return virtualCache;
    }

    /** 根据cbParams解析生成缓存回显对象
     * @param {object} config 属性配置对象
     * @param {object} searchData 数据仓库
     * @returns array
     */
    makeVirtualCache(config, searchData) {
        try {
            const isFalsy = val => [null, undefined, ''].includes(val);
            // step1：根据cbParams，从searchData中解析已选数据
            const data = config.cbParams.reduce((acc, item) => {
                const [sourceProp, destProp] = item.split('#');
                const valueKey = destProp || sourceProp;
                acc[sourceProp] = searchData[valueKey];
                return acc;
            }, {});

            // step2: 判断是否为空：只有当所有字段值都是fasly时才判断为空
            const keys = Object.keys(data);
            const isEmpty = keys.every(key => isFalsy(data[key]));
            if (isEmpty) return [];

            // step3: 将值字符分割成数组
            keys.forEach(key => {
                const value = isFalsy(data[key]) ? '' : data[key];
                data[key] = String(value).split(',');
            });

            // step4: 将{ key1: ['w','h'], key2: ['a', 'b'] } => [{key1: 'w', key2: 'a'}, {key1: 'h', key2: 'b'}]
            // 根据约定各字段的值长度应相等的，但在实际业务中发现不等情况（供应商）, 所以优先使用主字段的长度作为标准长度
            const mainKey = getCompareKeys(config)[0] || keys[0];
            const size = data[mainKey].length;
            const cache = [];

            for (let i = 0; i < size; i++) {
                const row = {};
                keys.forEach(key => {
                    row[key] = data[key][i];
                });
                cache.push(row);
            }
            return cache;
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }

        return [];
    }
    /**
     * 判断虚拟生成的缓存对象是否和本地的缓存一致
     * @param { object} localCache 本地缓存对象
     * @param { virtualCache } 根据cbParams解析出来的缓存对象
     * @returns boolean
     */
    isSameCaches(config, localCache, virtualCache) {
        if (localCache.length !== virtualCache.length) return false;
        const keys = getCompareKeys(config); // 根据配置，只判断指定字段
        if (keys.length) {
            return virtualCache.every(row => {
                return localCache.some(item => {
                    return keys.every(key => row[key] === item[key]);
                });
            });
        }
        return false;
    }
}
